import MapTarget from './MapTarget';
export default MapTarget;
